
import { PAGES } from "@consts";
export default {
	name: "InstructionCardsList",
	computed: {
		cardContent() {
			let intro1 =
				"Type one or more letters in at least one field in the correct order.";

			const intro2 =
				"Press the generate button when you’re ready, and reap the benefits.";

			if (this.$route.name === PAGES.WORDS_BY_LENGTH_LANDING_5_STARTS) {
				intro1 =
					"Enter up to 5 starting letters in their exact positions.";
			}

			if (this.$route.name === PAGES.WORDS_BY_LENGTH_LANDING_5_ENDS) {
				intro1 =
					"Enter up to 5 ending letters in their exact positions.";
			}

			if (this.$route.name === PAGES.WORDS_BY_LENGTH_LANDING_5_HAVING) {
				intro1 =
					"Enter up to 5 letters in a specific order. Use patterns like 'AS' or 'A_S'.";
			}

			return [
				{
					title: "Input Your Letters",
					intro: intro1,
					icon: "words-containing-outlined.svg",
				},
				{
					title: "Generate Your List",
					intro: intro2,
					icon: "search.svg",
				},
			];
		},
	},
};
